import {FavoriteResponse} from '../../store/backendApi';
import {FavoriteTripCard} from './FavoriteTripCard';

interface FavoritesGridProps {
  favoritesByYear: Record<string, FavoriteResponse[]>;
  onUnfollow: (tripId: string, linkSecret: string | null, e: React.MouseEvent) => void;
}

/**
 * Grid component that displays favorites grouped by year.
 */
export const FavoritesGrid = ({ favoritesByYear, onUnfollow }: FavoritesGridProps) => {
  return (
    <div className="w-full">
      {Object.entries(favoritesByYear).map(([year, yearFavorites]) => (
        <div key={year} className="mb-16">
          <div className="flex items-center mb-8">
            <h2 className="text-3xl text-main tracking-tight">{year}</h2>
            <div className="ml-6 flex-1 border-t-2 border-subtle"></div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">
            {yearFavorites.map((fav) => (
              <FavoriteTripCard key={fav.trip.id} favorite={fav} onUnfollow={onUnfollow} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
